import { graphql } from "gatsby";
import React from "react";
import useWindowWidth from "../../../hooks/useWindowWidth";
import WrappedSection from "../../WrappedSection/WrappedSection";
import { TextAndImageCardFlat } from "./TextAndImageCardFlat/TextAndImageCardFlat";
import { TextAndImageCardSquare } from "./TextAndImageCardSquare/TextAndImageCardSquare";
export interface ParagraphTextAndImageProps {
	title: string;
	text: string;
	buttonText: string;
	buttonUrl: string;
	imgSrc: string;
	imgAlt: string;
	jumpLinksTitle?: string;
}

export const getParagraphTextAndImageProps = ({
	field_heading,
	field_jump_links_title,
	field_text: { value: text },
	field_link,
	relationships: {
		field_featured_image: { field_media_image },
	},
}: Queries.ParagraphTextAndImageDataFragment): ParagraphTextAndImageProps => ({
	title: field_heading,
	text,
	buttonText: field_link?.title,
	buttonUrl: field_link?.uri,
	imgSrc: field_media_image.uri,
	imgAlt: field_media_image.alt,
	jumpLinksTitle: field_jump_links_title,
});
export const ParagraphTextAndImage: React.FC<ParagraphTextAndImageProps> = ({
	...props
}) => {
	const screenWidth = useWindowWidth();
	return (
		<WrappedSection sectionName="ParagraphTextAndImage">
			{screenWidth < 768 ? (
				<TextAndImageCardSquare {...props} />
			) : (
				<TextAndImageCardFlat {...props} />
			)}
		</WrappedSection>
	);
};

export const fragment = graphql`
    fragment ParagraphTextAndImageData on paragraph__text_and_image {
        __typename
        id
        field_heading
		field_jump_links_title
        field_text {
            value
        }
        field_link {
            title
            uri
        }
        relationships {
            field_featured_image {
                ...MediaImageData
            }
        }
    }
`;
